var app;
(function (app) {
    var support;
    (function (support) {
        var suggestion;
        (function (suggestion_1) {
            var SuggestionDirectiveController = /** @class */ (function () {
                /** @ngInject **/
                function SuggestionDirectiveController($scope, $http, suggestionService) {
                    var _this = this;
                    this.$scope = $scope;
                    this.$http = $http;
                    this.searchText = "";
                    this.items = [];
                    this.placeholder = "Digite aqui para pesquisar";
                    this.suggestion = { description: "" };
                    if (angular.isDefined($scope.id)) {
                        suggestionService.findById($scope.id)
                            .then(function (suggestion) {
                            _this.suggestion = suggestion;
                            if ($scope.useDescription) {
                                _this.placeholder = suggestion.description;
                            }
                        }, function (error) { throw new Error(error); });
                    }
                    if (angular.isFunction($scope.itemText)) {
                        this.itemText = $scope.itemText;
                    }
                    else {
                        this.itemText = this.defaultItemText;
                    }
                }
                SuggestionDirectiveController.prototype.selectedItemChange = function (item) {
                    this.$scope.selectedItem = item;
                };
                SuggestionDirectiveController.prototype.searchTextChange = function () {
                    var _this = this;
                    var _a;
                    var config = {
                        params: (_a = {},
                            _a[this.$scope.searchItem] = this.searchText,
                            _a)
                    };
                    var url = "";
                    if (angular.isDefined(this.suggestion)) {
                        url += "/" + this.suggestion.context;
                    }
                    url += this.$scope.api;
                    this.$http.get(url, config)
                        .success(function (items) { return _this.items = items; });
                };
                SuggestionDirectiveController.prototype.defaultItemText = function (item) {
                    return (angular.isDefined(item)) ? item.toString() : "";
                };
                return SuggestionDirectiveController;
            }());
            suggestion_1.SuggestionDirectiveController = SuggestionDirectiveController;
        })(suggestion = support.suggestion || (support.suggestion = {}));
    })(support = app.support || (app.support = {}));
})(app || (app = {}));
